import { showPopup } from 'lusha-widgets';
// Use this when you need an announcement popup.
// Announcement popup should only appear after privacy is approved and if no other announcement is currently showing.
// For other conditions like envConfig/platform/localstorage, control from outside
export const showAnnouncement = (Component, timeout, popupOptions = {}, userSettings) => userSettings.isPrivacyApproved &&
    setTimeout(() => {
        if (!userSettings.isMoreMenuV2AnnouncementShown) {
            showPopup(Component, Object.assign({ blockIfOpen: true }, popupOptions));
        }
    }, timeout);
